<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="(team_training_mng_member_type === TEAM_TRAINING_MNG_MEMBER_TYPE.APPLY ? '신청' : '취소') + ' 회원'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="padding:12px; overflow: auto; flex: 1;">
            <template v-if="join_schedule_members.length > 0">
                <div v-for="each, i in join_schedule_members" :key="i" style="display: flex; align-items: center; gap: 8px; padding-bottom: 10px; padding-top: 12px;" @click="showProfile(each)">
                    <div>
                        <ProfileImage style="width: 40px;" :image-path="each.image_path"></ProfileImage>
                    </div>
                    <div style="flex: 1; font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.nic_name }} <span style="font-weight: 700; color: var(--color-main);">{{ each.position }}</span></div>
                </div>
            </template>
            <template v-else>
                <div style="display: flex; justify-content: center; align-items: center; height: 100%; font-weight: 500; line-height: 24px; color: #808080;">트레이닝 {{ team_training_mng_member_type === TEAM_TRAINING_MNG_MEMBER_TYPE.APPLY ? '신청' : '취소' }} 회원이 없습니다.</div>
            </template>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from "../../common/MercenaryHeader";
import ProfileImage from "../../common/ProfileImage";
import { MEMBER_TYPE } from "../../../Constants";

export const TEAM_TRAINING_MNG_MEMBER_TYPE = {
    APPLY: 0,
    CANCEL: 2
}

export default {
    name: "TeamTrainingMngMember",
    components: { ProfileImage, MercenaryHeader },
    props: {
        team_training_mng_member_type: {
            type: Number,
            default: TEAM_TRAINING_MNG_MEMBER_TYPE.APPLY
        },
        join_schedule_idx: {
            type: [Number, String],
            default: -1
        }
    },
    data() {
        return {
            TEAM_TRAINING_MNG_MEMBER_TYPE: TEAM_TRAINING_MNG_MEMBER_TYPE,
            join_schedule_members: [],
        }
    },
    methods: {
        async getJoinScheduleMembers() {
            const parameters = {};
            parameters.is_apply_member = this.team_training_mng_member_type === TEAM_TRAINING_MNG_MEMBER_TYPE.APPLY;
            parameters.join_schedule_idx = this.join_schedule_idx;

            const res = await this.$Axios.get('/api/join/schedule/members/list', { params: parameters });
            const my_member_idx = this.$GlobalStore.loginInfo().idx;
            this.join_schedule_members = res.data.join_schedule_members.filter(each => each.member_idx != my_member_idx);
        },
        showProfile(member) {
            this.$Util.showProfile(member.member_idx, MEMBER_TYPE.USER, null, member.is_coach);
        }
    },
    created() {
        this.getJoinScheduleMembers();
    }
}
</script>

<style scoped></style>